module.exports = __webpack_public_path__ + "img/adventure.7b934c3b.jpg";